import React, { useState } from "react";
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Typography,
  CircularProgress,
  Fade,
} from "@material-ui/core";

import { Button } from "../Wrappers";
import { useGroupDispatch, joinGroup } from "../../context/GroupContext";
import { useTranslation } from "../../localization";

// Shared dialog for joining a group by name + passcode. Used from both the
// header's group dropdown and the no-groups screen. On success it reloads the
// user's groups (making the joined group active) and calls `onJoined`.
export default function JoinGroupDialog({ open, onClose, onJoined }) {
  var groupDispatch = useGroupDispatch();
  var t = useTranslation();

  var [groupName, setGroupName] = useState("");
  var [passcode, setPasscode] = useState("");
  var [error, setError] = useState(null);
  var [loading, setLoading] = useState(false);

  var canSubmit = groupName.length > 0 && passcode.length > 0 && !loading;

  function reset() {
    setGroupName("");
    setPasscode("");
    setError(null);
    setLoading(false);
  }

  function handleClose() {
    if (loading) {
      return;
    }
    reset();
    onClose();
  }

  async function handleSubmit() {
    if (!canSubmit) {
      return;
    }
    setError(null);
    setLoading(true);
    try {
      await joinGroup(groupDispatch, groupName, passcode);
      reset();
      onClose();
      if (onJoined) {
        onJoined(groupName);
      }
    } catch (err) {
      setError(err.message || t.joinGroup.joinError);
      setLoading(false);
    }
  }

  function handleKeypress(e) {
    if (e.charCode === 13) {
      handleSubmit();
    }
  }

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth="xs">
      <DialogTitle>{t.joinGroup.title}</DialogTitle>
      <DialogContent>
        <Fade in={Boolean(error)}>
          <Typography color="secondary" style={{ marginBottom: 8 }}>
            {error}
          </Typography>
        </Fade>
        <TextField
          autoFocus
          value={groupName}
          onChange={e => setGroupName(e.target.value)}
          onKeyPress={handleKeypress}
          margin="normal"
          label={t.joinGroup.groupName}
          type="text"
          fullWidth
        />
        <TextField
          value={passcode}
          onChange={e => setPasscode(e.target.value)}
          onKeyPress={handleKeypress}
          margin="normal"
          label={t.joinGroup.passcode}
          type="text"
          fullWidth
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color="secondary" disabled={loading}>
          {t.common.cancel}
        </Button>
        <Button
          onClick={handleSubmit}
          variant="contained"
          color="primary"
          disabled={!canSubmit}
        >
          {loading ? <CircularProgress size={20} /> : t.common.join}
        </Button>
      </DialogActions>
    </Dialog>
  );
}
